import React, { useState } from 'react'
import SecondHeader from '../components/SecondHeader/SecondHeader'
import Footer from '../components/Footer/Footer'
import SearchFilterBanner from '../components/SearchFilterBanner/SearchFilterBanner'
import SearchResultFilter from '../components/SearchResultFilterPage/SearchResultFilter'
import { useSelector } from 'react-redux'

const SearchFilterPage = () => {

    return (
        <>
            <SecondHeader />
            <SearchFilterBanner />
            <SearchResultFilter />
            <Footer />
        </>
    )
}

export default SearchFilterPage